<template>
	<PayAudioPlayerShell
		:data="data"
		:block-id="blockId"
		:editable="editable"
		:active="active"
		:h5="h5"
		:compact="compact"
		:id-key="idKey"
		@select="$emit('select')"
	/>
</template>

<script>
	import PayAudioPlayerShell from '../shared/PayAudioPlayerShell.vue';

	export default {
		name: 'GBlockPayAudioPlayer',
		components: { PayAudioPlayerShell },
		props: {
			data: {
				type: Object,
				required: true,
			},
			blockId: {
				type: String,
				default: '',
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
			compact: {
				type: Boolean,
				default: false,
			},
			idKey: {
				type: String,
				default: '',
			},
		},
		emits: ['select'],
	};
</script>
